import { NgModule } from '@angular/core';
import { RoleLabelPipe } from './role-label.pipe';

/**
 * Pipes compartidos del dashboard. Importar este módulo (no redeclarar los pipes)
 * en CommonComponentsModule, SharedModule y feature modules que los usen en plantillas.
 */
@NgModule({
  declarations: [RoleLabelPipe],
  exports: [RoleLabelPipe],
})
export class MunilyPipesModule {}
